import React, { useEffect } from 'react';

import Loading from '../../components/Loading';
import { useIsLoading } from '../../providers/loading';
import { Wrapper, Title } from './styled';

export default function About() {
  const { isLoading, setIsLoading } = useIsLoading();

  useEffect(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, [setIsLoading]);

  return (
    <Wrapper>
      <Loading isLoading={isLoading} />

      <Title>Contato</Title>
      <br />
      <Title>minhafigurinhadacopa@gmail.com</Title>
    </Wrapper>
  );
}
